export default __webpack_public_path__ + "static/media/Ballroll_00265.080d23a8.png";